import { render, staticRenderFns } from "./FlotasCarousel.vue?vue&type=template&id=3104d35c&"
import script from "./FlotasCarousel.vue?vue&type=script&lang=ts&"
export * from "./FlotasCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./FlotasCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3104d35c', component.options)
    } else {
      api.reload('3104d35c', component.options)
    }
    module.hot.accept("./FlotasCarousel.vue?vue&type=template&id=3104d35c&", function () {
      api.rerender('3104d35c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/ControlFlotas/FlotasCarousel.vue"
export default component.exports